let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("13nGx")).then(() => parcelRequire('jCYvp'));